import React,{useState, useEffect} from 'react';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import '../../scss/partials/assignDevices/assignDevices.css';
import BreadCrumb from '../shared/BreadCrumbs';
import { connect } from 'react-redux';
import LoadingSpinner from '../shared/LoadingSpinner';
import { loadCategoryDetails, clearExistingAssignments } from '../../redux/actions/assignDevicesActions';
import ShowCategory from './ShowCategory';
import AccessControl from '../../AccessControl';
import permissions from '../../permissionsList';


export const UnconnectedAssignDevices = ( props) => {
    
    const { alarmDeviceTypes, apiSpinner } = props;
    const [showCategory, setShowCategory] = useState(false);
    const optionArr = [];

    useEffect(()=>{
        let deviceTypes = alarmDeviceTypes ? Object.values(alarmDeviceTypes) : [];
        if (deviceTypes.length > 0){
            var firstelement = deviceTypes.shift()
            deviceTypes.sort(function (a, b) {
                let aParam = a['description'];
                let bParam = b['description'];
                if (typeof aParam === 'string') {
                  aParam = aParam.toUpperCase(); // ignore upper and lowercase
                }
                if (typeof bParam === 'string') {
                  bParam = bParam.toUpperCase(); // ignore upper and lowercase
                }
          
                if (aParam < bParam) {
                  return -1;
                }
                if (aParam > bParam) {
                  return 1;
                }
                // names must be equal
                return 0;
              })
           deviceTypes.unshift(firstelement)
        }
        deviceTypes.forEach((device)=>{
            optionArr.push({
                id:device.alarm_device_type,
                desc:device.description,
                checked:false
            })
        })
        setCategoryOption([...optionArr]);
    },[alarmDeviceTypes]) // eslint-disable-line

    const [categoryOption,setCategoryOption] = useState([...optionArr]);

    function handleCategorySubmit(checkedCategory){
        handleClearAssignments(checkedCategory);
        handleCloseCategory();
    }
    
    const [clearTriggered, setClearTriggered] = useState(false);

    useEffect(() => {
        props.dispatch(loadCategoryDetails());
    }, []); // eslint-disable-line

    useEffect(() =>{
        if(apiSpinner.clearAssignmentReturned)
            setClearTriggered(false)
    }, [apiSpinner.clearAssignmentReturned]);

    function handleClearAssignments(selectedCategory){
        setClearTriggered(true);
        
        let category=[];
        if(selectedCategory[0].checked){
            category.push("all");
        }
        else{
            let temp = selectedCategory.slice(1);
            temp.forEach((c)=>{
                if(c.checked)
                    category.push(c.id);
            })
        }
        props.dispatch(clearExistingAssignments({category:category.toString()}));
    }

    function handleShowCategory(){
        setShowCategory(true);
    }
    function handleCloseCategory(){
        setShowCategory(false);
    }

    function displayContent(){
    return (
    <React.Fragment>
        <div>
        Running this tool will allow you to assign devices to either Users or Units based on how they are named.<br/>
        You may run this as many times as you need.<br/>
        You will want to make sure the following is true:<br/>
        <ul className="no-margin">
            <li key={1} className="text-bold">All Users/Units are named properly and will match the correct device</li>
            <li key={2} className="text-bold">All Devices are named properly and will match the correct User/Unit</li>
            <li key={3} className="text-bold">If Assigning POIs, make sure they are all named properly and will match their Unit</li>
        </ul>
        Example:<br/>
        <ul className="no-margin">
            <li key={4} className="text-bold">If a unit is named "West 101" this will match devices that contain the text "West 101".</li>
            <ul className="no-margin">
                <li key={5} >Examples of devices that will match "West 101 Pendant", "Pullcord West 101"</li>
                <li key={6} >Examples of devices that will not match "Pendant 101", "101 West Pullcord"</li>
            </ul>
            <li key={7} className="text-bold">If a user is named "Tom Smith" this will match devices that contain both "Tom" and "Smith"</li>
            <ul className="no-margin">
                <li key={8} >Examples of devices that will match "Smith,Tom", "101 Pendant Tom Smith", "101 Tom Smith Pullcord"</li>
            </ul>
        </ul>
        Clear all assignments option allow you to clear existing assignments for units and users by selecting all or specific category.
        </div>
        <div className="flex-spread">
        <div className="center-self">
            {<Link
                data-test="assignment-options-button"
                className="text-medium link-button button-secondary button-xsm link-secondary"
                to="options">
                <span />{"Assign Devices"}
            </Link>}
        </div>
        <div>
            <button onClick={handleShowCategory}
            className="center text-medium link-button button-secondary button-xsm link-secondary"
            data-test="clear-existing-assignment-button">Clear assignments</button>
        </div>
    </div>
    </React.Fragment>);
    }

    function displayPage(){
        if( !clearTriggered  && apiSpinner.categoryListReturned ){
            return displayContent();}
        else{
          return (
            <div className="loading-spinner__user-list-container">
              <LoadingSpinner />
            </div>
          );
        } 
    }

    const assignDevicesTitleText = (
        <FormattedMessage
            id="assignDevices.assignDevicesText"
            defaultMessage="Assign devices to Units/Users"
            description="Assign devices display title"
        />);

    const BreadCrumbArr = [
        {link:"/main/device_main.php",display:"Dashboard",type:"php"},
        {link:"/admin/install_setup.php",display:"Install Setup",type:"php"}
    ];

    return (
    <div className="container-full" data-test="assignDevices-route">
        <div className="layout-container--wide content-container content-container--column content-container--shadow" 
        data-test="display-container">
            <AccessControl feature={permissions.static.devices.assignDevices}
            permissionMessage={true}>
                {showCategory ? <ShowCategory categoryOptionsArr={categoryOption}
                submitText={"Clear"} handleSubmit={handleCategorySubmit} handleClose={handleCloseCategory}/> : ""}
                <div className="flex-start width-100" data-test="breadcrumb">
                    <BreadCrumb linkArr={BreadCrumbArr}></BreadCrumb>
                </div>
                <div className="width-100">
                    <h1 className="no-margin text-center" data-test="display-title">{assignDevicesTitleText}</h1>
                </div>
                {displayPage()}
            </AccessControl>
        </div>
    </div>
    );
  };

  const mapStateToProps = (state, ownProps) => {
    return {
        alarmDeviceTypes: state.assignDevices.categoryList,
        apiSpinner: state.ui.apiSpinner,
    };
};

export default connect(mapStateToProps)(UnconnectedAssignDevices);